module.exports = __webpack_public_path__ + "static/lorena-1b6f3b99e80b7c5b0c60736abdb21445.jpg";